import request from "@/utils/request";

export function saveShopDistributorEc(params) {
  return request({
    url: "/api/system/shopDistributorEc/saveShopDistributorEc",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/mine/distribution.js